/* Translated: yes */
import Vue from 'vue';
import Router from 'vue-router';
import StartPage from '@/components/Pages/StartPage';

import AccomodationsPage from '@/components/Pages/Accomodation/AccomodationsPage';
import AccomodationsPageInfo from '@/components/Pages/Accomodation/AccomodationsPageInfo';
import AccomodationsPagePrice from '@/components/Pages/Accomodation/AccomodationsPagePrice';
import AccomodationsConfirm from '@/components/Pages/Accomodation/AccomodationsConfirm';
import AccomodationsCompare from '@/components/Pages/Accomodation/AccomodationsCompare';
import AddonsPage from '@/components/Pages/Accomodation/AddonsPage';
import Accomodation from '@/components/Admin/Accomodation';

import SkiRentalOnSitePage from '@/components/Pages/SkiRental/SkiRentalOnSitePage';

import SkiRentalPage from '@/components/Pages/SkiRental/SkiRentalPage';
import SkiRentalUser from '@/components/Pages/SkiRental/SkiRentalUser';
import SkiRentalUserProducts from '@/components/Pages/SkiRental/SkiRentalUserProducts';
import SkiRentalUserOverview from '@/components/Pages/SkiRental/SkiRentalUserOverview';
import SkiRentalConfirm from '@/components/Pages/SkiRental/SkiRentalConfirm';

import SkiPassPage from '@/components/Pages/SkiPass/SkiPassPage';
import SkiPassOnSitePage from '@/components/Pages/SkiPass/SkiPassOnSitePage';
import SkiPassUser from '@/components/Pages/SkiPass/SkiPassUser';
import SkiPassUserOverview from '@/components/Pages/SkiPass/SkiPassUserOverview';
import SkiPassConfirm from '@/components/Pages/SkiPass/SkiPassConfirm';

import SkiSchoolPage from '@/components/Pages/SkiSchool/SkiSchoolPage';
import SkiSchoolOverview from '@/components/Pages/SkiSchool/SkiSchoolOverview';

import ActivitiesPage from '@/components/Pages/ActivitiesPage';

import OnSitePage from '@/components/Pages/OnSitePage';

import MyPage from '@/components/Pages/MyPages/MyPage';
import LoginPage from '@/components/Pages/MyPages/LoginPage';
import AdminPage from '@/components/Pages/MyPages/AdminPage';

import RequestResetPassword from '@/components/Pages/RequestResetPassword';
import ResetPassword from '@/components/Pages/ResetPassword';
import MyPageJourney from '@/components/Pages/MyPages/MyPageJourney';
import MyPageBookings from '@/components/Pages/MyPages/MyPageBookings';
import MyBooking from '@/components/Pages/MyPages/MyBooking';
import MyBookingV2 from '@/components/Pages/MyPages/MyBookingV2';
import MyPageDetails from '@/components/Pages/MyPages/MyPageDetails';
import MyPagePassword from '@/components/Pages/MyPages/MyPagePassword';
import MyPageLogout from '@/components/Pages/MyPages/MyPageLogout';

import ShoppingCartPage from '@/components/Pages/ShoppingCartPage';
import CheckoutPage from '@/components/Pages/CheckoutPage';

import Settings from '@/components/Admin/Settings';
import CommandSyncer from '@/components/Admin/CommandSyncer';
import EmailReport from '@/components/Admin/EmailReport';
import GdprCleanup from '@/components/Admin/GdprCleanup';
import Texts from '@/components/Admin/Texts';
import OrderList from '@/components/Admin/OrderList';
import OrderSingle from '@/components/Admin/OrderSingle';
import Translation from '@/components/Admin/Translation';
import Notifications from '@/components/Admin/Notifications';
import Users from '@/components/Admin/Users';
import Logs from '@/components/Admin/Logs';
import Tokens from '@/components/Admin/Tokens';
import AuthCallback from '@/components/Admin/AuthCallback';

import PaymentPage from '@/components/Pages/PaymentPage';
import PaymentServiceCheckoutConfirmationPage from '@/components/Pages/PaymentServiceCheckoutConfirmationPage';
import PayedWithCodeConfirmationPage from '@/components/Pages/PayedWithCodeConfirmationPage';

import PayedExternally from '@/components/Pages/PayedExternally';

import store from '@/store';
import API from '@/classes/API';

Vue.use(Router);

const router = new Router({
  // mode: 'history',
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    if (to.path.match(/\/boenden/) && from.path.match(/\/boenden/)) {
      return null;
    }
    return { x: 0, y: 0 };
  },
  routes: [
    {
      path: '/dela/:category/:parameters',
      name: 'share',
      redirect: (to) => {
        const category = to.params.category;
        const parms = to.params.parameters;
        if (category === 'j') {
          return `/jamfor-boenden?boenden=${parms}`;
        }
        return '/';
      },
    },
    {
      path: '/',
      name: 'start',
      component: StartPage,
    },
    {
      path: '/boenden',
      name: 'accomodation list',
      component: AccomodationsPage,
      children: [
        {
          path: 'info/:poolId/:unitId',
          name: 'accomodation info',
          component: AccomodationsPageInfo,
          meta: {
            isModal: true,
          },
        },
        {
          path: 'info/:slug',
          name: 'accomodation info on slug',
          component: AccomodationsPageInfo,
          meta: {
            isModal: true,
          },
        },
        {
          path: 'info/:poolId/:unitId/:arrival/:departure',
          name: 'accomodation info with price',
          component: AccomodationsPageInfo,
          meta: {
            isModal: true,
          },
        },
        {
          path: 'info/:slug/:arrival/:departure',
          name: 'accomodation info with price on slug',
          component: AccomodationsPageInfo,
          meta: {
            isModal: true,
          },
        },
        {
          path: 'pris/:poolId/:unitId',
          name: 'accomodation price',
          component: AccomodationsPagePrice,
          meta: {
            isModal: true,
          },
        },
        {
          path: 'pris/:slug',
          name: 'accomodation price on slug',
          component: AccomodationsPagePrice,
          meta: {
            isModal: true,
          },
        },
      ],
    },
    {
      path: '/jamfor-boenden',
      name: 'compare-accomodations',
      component: AccomodationsCompare,
      meta: {
        forceTop: true,
      },
      children: [
        {
          path: 'info/:poolId/:unitId',
          name: 'compare-accomodations accomodation info',
          component: AccomodationsPageInfo,
          meta: {
            isModal: true,
            cssPage: 'accomodation info',
          },
        },
        {
          path: 'info/:slug',
          name: 'compare-accomodations accomodation info on slug',
          component: AccomodationsPageInfo,
          meta: {
            isModal: true,
            cssPage: 'accomodation info on slug',
          },
        },
        {
          path: 'pris/:poolId/:unitId',
          name: 'compare-accomodations accomodation price',
          component: AccomodationsPagePrice,
          meta: {
            isModal: true,
            cssPage: 'accomodation price',
          },
        },
        {
          path: 'pris/:slug',
          name: 'compare-accomodations accomodation price on slug',
          component: AccomodationsPagePrice,
          meta: {
            isModal: true,
            cssPage: 'accomodation price on slug',
          },
        },
      ],
    },
    {
      path: '/boenden/bekrafta',
      name: 'confirm-accomodation',
      component: AccomodationsConfirm,
      meta: {
        forceTop: true,
      },
      children: [
        {
          path: 'info/:slug',
          name: 'confirm-accomodation accomodation info',
          component: AccomodationsPageInfo,
          meta: {
            isModal: true,
            cssPage: 'accomodation info',
          },
        },
        {
          path: 'info/:slug',
          name: 'confirm-accomodation accomodation info on slug',
          component: AccomodationsPageInfo,
          meta: {
            isModal: true,
            cssPage: 'accomodation info on slug',
          },
        },
        {
          path: 'info/:slug/:arrival/:departure',
          name: 'confirm-accomodation accomodation info with price',
          component: AccomodationsPageInfo,
          meta: {
            isModal: true,
            cssPage: 'accomodation info with price',
          },
        },
        {
          path: 'info/:slug/:arrival/:departure',
          name: 'confirm-accomodation accomodation info with price on slug',
          component: AccomodationsPageInfo,
          meta: {
            isModal: true,
            cssPage: 'accomodation with price on slug',
          },
        },
        {
          path: 'pris/:slug',
          name: 'confirm-accomodation accomodation price',
          component: AccomodationsPagePrice,
          meta: {
            isModal: true,
            cssPage: 'accomodation price',
          },
        },
        {
          path: 'pris/:slug',
          name: 'confirm-accomodation accomodation price on slug',
          component: AccomodationsPagePrice,
          meta: {
            isModal: true,
            cssPage: 'accomodation price on slug',
          },
        },
      ],
    },
    {
      path: '/boenden/tillval',
      name: 'addons',
      component: AddonsPage,
    },
    {
      path: '/boenden/tillval-tillagg',
      name: 'addons extra',
      component: AddonsPage,
    },
    {
      path: '/boenden/bilder',
      name: 'accomodation image list',
      component: AccomodationsPage,
      meta: {
        view: 'images',
      },
      children: [
        {
          path: 'info/:slug',
          name: 'accomodations accomodation images info on slug',
          component: AccomodationsPageInfo,
          meta: {
            isModal: true,
            cssPage: 'accomodation info on slug',
            view: 'images',
          },
        },
        {
          path: 'info/:slug/:arrival/:departure',
          name: 'confirm-accomodation accomodation info image with price on slug',
          component: AccomodationsPageInfo,
          meta: {
            isModal: true,
            cssPage: 'accomodation with price on slug',
            view: 'images',
          },
        },
      ],
    },
    // Ski rental
    {
      path: '/pa-plats',
      name: 'on site',
      component: OnSitePage,
    },
    {
      path: '/skidhyra-pa-plats',
      name: 'ski rental on site',
      component: SkiRentalOnSitePage,
    },
    {
      path: '/skidhyra',
      name: 'ski rental',
      component: SkiRentalPage,
    },
    {
      path: '/skidhyra/oversikt',
      name: 'ski rental overview',
      component: SkiRentalUserOverview,
    },
    {
      path: '/skidhyra/bekrafta',
      name: 'ski rental confirm',
      component: SkiRentalConfirm,
    },
    {
      path: '/skidhyra/:person',
      name: 'ski rental person',
      component: SkiRentalUser,
    },
    {
      path: '/skidhyra/:person/produkter',
      name: 'ski rental person search',
      component: SkiRentalUserProducts,
    },
    {
      path: '/liftkort',
      name: 'ski pass',
      component: SkiPassPage,
    },
    {
      path: '/liftkort-pa-plats',
      name: 'ski pass on site',
      component: SkiPassOnSitePage,
    },
    {
      path: '/liftkort/oversikt',
      name: 'ski pass overview',
      component: SkiPassUserOverview,
    },
    {
      path: '/liftkort/bekrafta',
      name: 'ski pass confirm',
      component: SkiPassConfirm,
    },
    {
      path: '/liftkort/:person',
      name: 'ski pass person',
      component: SkiPassUser,
    },
    {
      path: '/skidskola',
      name: 'ski school',
      component: SkiSchoolPage,
    },
    {
      path: '/cykelskola',
      name: 'bike school',
      component: SkiSchoolPage,
    },
    {
      path: '/skidskola-pa-plats',
      name: 'ski school overview on site',
      component: SkiSchoolOverview,
    },
    {
      path: '/skidskola/oversikt',
      name: 'ski school overview',
      component: SkiSchoolOverview,
    },
    {
      path: '/cykelskola/oversikt',
      name: 'bike school overview',
      component: SkiSchoolOverview,
    },
    {
      path: '/aktiviteter',
      name: 'activities',
      component: ActivitiesPage,
    },
    {
      path: '/aktiviteter/boka/:pool',
      name: 'activities book',
      component: ActivitiesPage,
    },
    {
      path: '/konto/aterstall-losenord',
      name: 'request reset password',
      component: RequestResetPassword,
    },
    {
      path: '/konto/skapa-losenord',
      name: 'request new password',
      component: RequestResetPassword,
    },
    {
      path: '/konto/nytt-losenord/:token',
      name: 'reset password',
      component: ResetPassword,
    },
    {
      path: '/konto/skapa-losenord/:token',
      name: 'create password',
      component: ResetPassword,
    },
    {
      path: '/logga-in',
      name: 'login',
      component: LoginPage,
    },
    {
      path: '/admin/auth/callback',
      name: 'admin-auth-callback',
      component: AuthCallback,
    },
    {
      path: '/admin',
      name: 'admin',
      component: AdminPage,
      redirect: () => '/admin/settings',
      meta: {
        requiresAdmin: true,
      },
      children: [
        {
          path: 'translations',
          name: 'admin-translations',
          component: Translation,
          meta: {
            requiresAdmin: true,
          },
        },
        {
          path: 'accomodations',
          name: 'admin-accomodations',
          component: Accomodation,
          meta: {
            requiresAdmin: true,
          },
        },
        {
          path: 'settings',
          name: 'admin-settings',
          component: Settings,
          meta: {
            requiresAdmin: true,
          },
        },
        {
          path: 'command-sync',
          name: 'admin-command-sync',
          component: CommandSyncer,
          meta: {
            requiresAdmin: true,
          },
        },
        {
          path: 'email-report',
          name: 'admin-email-report',
          component: EmailReport,
          meta: {
            requiresAdmin: true,
          },
        },
        {
          path: 'gdpr-cleanup',
          name: 'admin-gdpr-cleanup',
          component: GdprCleanup,
          meta: {
            requiresAdmin: true,
          },
        },
        {
          path: 'texts',
          name: 'admin-texts',
          component: Texts,
          meta: {
            requiresAdmin: true,
          },
        },
        {
          path: 'notifications',
          name: 'admin-notifications',
          component: Notifications,
          meta: {
            requiresAdmin: true,
          },
        },
        {
          path: 'users',
          name: 'admin-users',
          component: Users,
          meta: {
            requiresAdmin: true,
          },
        },
        {
          path: 'logs',
          name: 'admin-logs',
          component: Logs,
          meta: {
            requiresAdmin: true,
          },
        },
        {
          path: 'tokens',
          name: 'admin-tokens',
          component: Tokens,
          meta: {
            requiresAdmin: true,
          },
        },
        {
          path: 'stats/orders',
          name: 'admin-stats-orders',
          component: OrderList,
          meta: {
            requiresAdmin: true,
          },
          children: [
            {
              path: ':orderId',
              name: 'admin-stats-orders-detail',
              component: OrderSingle,
              meta: {
                requiresAdmin: true,
              },
            },
          ],
        },
      ],
    },
    {
      path: '/mina-sidor/resa/:bookingNumber',
      name: 'my journey booking',
      component: MyBookingV2,
      meta: {
        page: 'journey',
      },
      children: [
        {
          path: 'boende/:slug',
          name: 'my journey accomodation info on slug',
          component: AccomodationsPageInfo,
          meta: {
            isModal: true,
          },
        },
        {
          path: 'detaljer',
          name: 'my journey detailed',
          component: MyBooking,
          meta: {
            page: 'bookings',
            isModal: true,
          },
        },
      ],
    },
    {
      path: '/mina-sidor',
      name: 'my pages',
      component: MyPage,
      redirect: () => '/mina-sidor/resa',
      children: [
        {
          path: 'resa',
          name: 'my pages journey',
          component: MyPageJourney,
          meta: {
            page: 'journey',
            isSub: true,
          },
        },
        {
          path: 'uppgifter',
          name: 'my pages details',
          component: MyPageDetails,
          meta: {
            page: 'details',
            isSub: true,
          },
        },
        {
          path: 'bokningar',
          name: 'my pages bookings',
          component: MyPageBookings,
          meta: {
            page: 'bookings',
          },
          children: [
            {
              path: ':bookingNumber',
              name: 'my booking detailed',
              component: MyBooking,
              meta: {
                page: 'bookings',
                isSub: true,
                isModal: true,
              },
            },
          ],
        },
        {
          path: 'losenord',
          name: 'my pages password',
          component: MyPagePassword,
          meta: {
            page: 'password',
            isSub: true,
          },
        },
        {
          path: 'logga-ut',
          name: 'my pages logout',
          component: MyPageLogout,
          meta: {
            page: 'logout',
            isSub: true,
          },
        },
      ],
    },
    {
      path: '/varukorg',
      name: 'shopping cart',
      component: ShoppingCartPage,
    },
    {
      path: '/kassa',
      name: 'checkout',
      component: CheckoutPage,
    },
    {
      path: '/betala/bekraftelse',
      name: 'payment confirmation',
      component: PaymentServiceCheckoutConfirmationPage,
    },
    {
      path: '/betalat/bekraftalse',
      name: 'payed externally',
      component: PayedExternally,
    },
    {
      path: '/betala/bekraftelse-kod',
      name: 'payedwithcode',
      component: PayedWithCodeConfirmationPage,
    },
    {
      path: '/betala',
      name: 'payment',
      component: PaymentPage,
    },
  ],
});

router.beforeEach(async (to, from, next) => {
  if (to.meta && to.meta.requiresAdmin) {
    if (!store.state.user || !store.state.user.email || !store.state.user.isAdmin) {
      try {
        const response = await API.get('/admin/user');
        if (response && response.user) {
          const u = response.user;
          u.isAdmin = Boolean(u.isAdmin || u.can_accomodations || u.can_translations);
          store.state.user = u;
        }
      } catch (e) {
        // Ignore session loading error
      }
    }

    if (!store.state.user || !store.state.user.isAdmin) {
      return next('/logga-in?admin=1');
    }
  }

  const regex1 = new RegExp('^/skidhyra-pa-plats|/skidhyra/|/skidskola-pa-plats|/pa-plats|/liftkort-pa-plats|/pa-plats|/liftkort/');
  const url = `/pa-plats?site=${store.state.isOnWhichSite}`;
  if (store.state.isOnSite && (!to.fullPath.match(regex1))) {
    return next(url);
  }
  if (to.name === 'ski rental' && from.name === 'ski rental person') {
    const stage = from.matched[0].instances.default.stage;
    if (stage <= 13 || window.screenSize() > window.screenMobile) {
      if (confirm(window.SITE_CONFIG.translations.general['cancel-booking-question-text'])) { // eslint-disable-line
        store.state.cart.rentals = [];
        return next();
      }
      return next(false);
    }
    if (stage === 16) {
      from.matched[0].instances.default.stage = 13; // eslint-disable-line
    } else if (stage === 20) {
      from.matched[0].instances.default.stage = 16; // eslint-disable-line
    } else if (stage === 30) {
      from.matched[0].instances.default.stage = 20; // eslint-disable-line
    } else if (stage === 40) {
      from.matched[0].instances.default.stage = 30; // eslint-disable-line
    }
    return next(false);
  }

  return next();
});

router.afterEach((to, from) => {
  const path = to.path;
  let query = Object.assign({}, to.query);
  delete query.flow;
  delete query.no;
  delete query.d;
  delete query.c;

  const host = window.location.host;

  let url = `https://${host}/bokning${path}`;

  query = Object.keys(query).map(key => `${key}=${query[key]}`).join('&');

  if (query.length > 1) {
    url = `${url}?${query}`;
  }

  // window.ga('send', 'pageview', `/bokning${path}`);
  // window.ga('send', 'event', 'Pageview', 'changed', `/bokning${path}`);
  // window.fbq('track', 'PageView');
  // window.gtag('event', 'page_view', {
  //   page_location: `/bokning${path}`,
  //   page_title: `/bokning${path}`,
  //   page_path: `/bokning${path}`,
  //   send_to: window.GA4_ID,
  // });
  console.log(url);

  if (to.query.debug) {
    store.state.isDebugging = true;
  }

  document.body.classList.remove('modal-opened');

  if (window.jQuery) {
    window.jQuery('nav.main-nav').removeClass('active');
    window.jQuery('body').removeClass('is-navigating');
  }

  if (to.meta.isModal) {
    document.body.classList.add('modal-opened');
  }

  if (!to.meta.forceTop) {
    if (from.meta.isModal || from.meta.isSub) {
      return;
    }
    if (to.meta.isModal || to.meta.isSub) {
      return;
    }
  }
  const myDiv = document.getElementById('app');
  if (myDiv) {
    myDiv.scrollTop = 0;
  }
  document.body.scrollTop = 0;
  scroll(0, 0);

  store.commit('closeAllModals');
  store.commit('closeTimeoutModal');
});

/* router.afterEach((to) => {
  setTimeout(() => {
    try {
      $this.$el.dispatchEvent(new Event('checkformodals'));
    } catch (e) {
      // handle IE not supporting Event constructor
      const evt = document.createEvent('Event');
      evt.initEvent('checkformodals', true, false);
      $this.$el.dispatchEvent(evt);
    }
  }, 1);
}); */

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js